<template>
    <footer>
        <div class="container container-medium">
            <div class="row">
                <div class="col-lg-3 d-none d-lg-block">
                    <ul>
                        <li class="footer-title">
                            <strong>
                                <router-link :to="{name: 'new-account'}">
                                    {{ $t('footer_new_account_link') }}
                                </router-link>
                            </strong>
                        </li>
                        <!-- <li><a href="https://e-rovinieta.ro/ro/?from=beta">Versiune veche E-rovinieta.ro</a></li>
                        <li><a href="https://taxa-pod-fetesti.ro/ro/?from=beta">Versiune veche Taxa-pod-fetesti.ro</a></li> -->
                    </ul>
                </div>
                <div class="col-lg-3 d-none d-lg-block ">
                    <ul>
                        <li><router-link :to="{name: 'how-it-works'}">{{ $t('header_how_does_it_work') }}</router-link></li>
                        <li><router-link :to="{name: 'questions'}">{{ $t('faq_title') }}</router-link></li>
                        <li><router-link :to="{name: 'info'}">{{ $t('info') }}</router-link></li>
                        <li><router-link :to="{name: 'about-us'}">{{ $t('about_us') }}</router-link></li>
                    </ul>
                </div>
                <div class="col-lg-3 d-none d-lg-block">
                    <ul>
                        <li><router-link :to="{name: 'terms'}">{{ $t('terms') }}</router-link></li>
                        <li><router-link :to="{name: 'confidentiality'}">{{ $t('new_account_pc') }}</router-link></li>
                        <li><router-link :to="{name: 'cookies'}">{{ $t('cookies') }}</router-link></li>
                    </ul>
                </div>
                <div class="col-lg-3">
                    <ul>
                        <li><router-link :to="{name: 'contact'}">Contact</router-link></li>
                    </ul>
                    <p class="footer-small-text">{{ $t('footer_copyright', { currentYear: currentYear }) }}</p>
                    <p class="footer-small-text">Developed by <a href="https://controlf5.ro" target="_blank"><img src="../media/logo-controlf5.png" class="ctrlf5" alt="Control F5"></a></p>
                    <p>
                        <a href="https://romania.payu.com/" target="_blank" rel="nofollow"><img src="../media/payu.png" class="payu" alt="PayU"></a>
                    </p>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>

export default {
    name: 'Footer',
    data: function() {
        return {
        };
    },
    components: {

    },
    props: {
    },
    computed: {
      currentYear: function () {
        return new Date().getFullYear();
      }
    },
    mounted: function() {
    },
    methods: {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

$lightgrey: lightgrey;

footer {
    width: 100%;
    background-color: #EEEDEC;
    padding: 60px 0;
    font-size: 12px;

    ul > li {
        margin-bottom:1rem;
        font-weight: 600;
        font-size: 14px;
        &.footer-title {
        }
    }

    p {
        color: #6F6F6F;
        font-weight: 300;
    }
}

.footer-mask {
    height: 260px;
}

.logo {
    max-height: 150px;
}

img {
    max-width: 100%;
}

a {
    text-decoration: none;

    &:hover{
        text-decoration: underline;
        color: #737880;
    }
}
.links {
    a {
        display: inline-block;
        margin: 0 5px;
    }
}

.ctrlf5 {
    max-height: 35px;
    vertical-align: middle;
    margin-left: 5px;
    margin-top: 5px;
}

.payu {
    max-height: 35px;
    vertical-align: middle;
    margin-left: 5px;
    margin-right: 5px;
    margin-top: 5px;
}

@media only screen and (max-width: 991px) {
    footer {
        text-align: center;
        a {
            font-size: 18px;
        }
        p {
            font-size: 14px;
        }
    }
}

.footer-small-text {
    font-size: 12px;
}

</style>
